// src/components/TopBar.js

import React from 'react';

function TopBar({ lang, setLang, currentTime, translations }) {
  return (
    <div className="top-bar">
      <span>{translations.greeting[lang]}</span>
      <div className="top-right">
        <span
          onClick={() => setLang("en")}
          className={`lang-toggle ${lang === 'en' ? 'active-lang' : ''}`}
          style={{ cursor: 'pointer' }}
        >
          EN
        </span>
        <span className="separator">|</span>
        <span
          onClick={() => setLang("zh")}
          className={`lang-toggle ${lang === 'zh' ? 'active-lang' : ''}`}
          style={{ cursor: 'pointer' }}
        >
          CN
        </span>
        <span className="separator">|</span>
        <span className="time">
          {currentTime.toLocaleString(lang === 'zh' ? 'zh-CN' : 'en-US', { hour12: false })}
        </span>
      </div>
    </div>
  );
}

export default TopBar;


